module.exports = __webpack_public_path__ + "static/media/f-story-icon-white-icon-only.c98ee600.png";